<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

  export default {
    name: 'app'
  }
</script>


<style lang="less">
  @import "./assets/less/var.less";
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    &> div {
      height: 100%;
    }
  }
  body,html {
    background-color: @backColor;
    height: 100%;
  }
  .tab-box {
    // padding-bottom: 80px;
  }
  .van-tabbar-item--active {
    color: @defaultColor;
  }
</style>


// WEBPACK FOOTER //
// src/App.vue